<template>
  <div class="category-bar">
    <div
      v-for="category in categories"
      :key="category.name"
      class="category py-1 px-2 py-sm-3 px-sm-5"
      :class="shouldHideAverages ? 'should-hide-averages' : ''"
      @click="onOpenCategoryDetails(category)"
    >
      <div class="name-and-progress pb-1">
        <div class="d-flex justify-content-between">
          <p class="fs-4 mb-1 category-bars-table-title">
            {{ category.title }}
          </p>
          <div
            v-if="
              category.description &&
              category.description !== 'null' &&
              category.description.length < 25
            "
          >
            {{ category.description }}
          </div>
        </div>
        <div
          v-if="!shouldShowColorSegments && !shouldHideAverages"
          class="progress"
          :class="category.value === 0 ? 'outline' : ''"
        >
          <div
            class="progress-bar"
            :class="`progress-bar-${getBarColor(category.value)}`"
            :style="`width: ${(category.value / 10) * 100}%`"
            role="progressbar"
            :aria-valuenow="category.value"
            aria-valuemin="0"
            aria-valuemax="10"
          ></div>
        </div>
        <div v-if="shouldShowColorSegments" class="progress">
          <div
            class="progress-bar"
            :class="`progress-bar-${getBarColor(1)}`"
            role="progressbar"
            :style="`width: ${category.colors.percentageRed}%`"
          ></div>
          <div
            class="progress-bar"
            :class="`progress-bar-${getBarColor(5)}`"
            role="progressbar"
            :style="`width: ${category.colors.percentageYellow}%`"
          ></div>
          <div
            class="progress-bar"
            :class="`progress-bar-${getBarColor(8)}`"
            role="progressbar"
            :style="`width: ${category.colors.percentageGreen}%`"
          ></div>
        </div>
      </div>
      <div
        v-if="showTrendForCategory(data) || true"
        id="with-trend"
        class="d-flex flex-column justify-content-end ms-3"
      >
        <TrendArrow
          :id="`${category.name}-trend`"
          :title="$tr(category.messages, 'title')"
          type="category"
          :regressionValues="category.regressionValues"
          :averages="category.averages"
        />
        <p
          v-if="category.value !== undefined && category.value >= 0"
          class="value fs-2 mb-0"
        >
          {{ $localeNumber(category.value) }}
        </p>
        <div v-else class="value-placeholder"></div>
      </div>
      <div
        v-else
        id="without-trend"
        class="d-flex flex-column justify-content-end ms-3"
      >
        <p
          v-if="category.value !== undefined && category.value >= 0"
          class="value fs-2 mb-0"
        >
          {{ $localeNumber(category.value) }}
        </p>
        <p v-else class="value-placeholder"></p>
      </div>
    </div>
  </div>
</template>

<script>
import TrendArrow from '@/components/shared/TrendArrow.vue'

export default {
  name: 'CategoriesBarsTable',
  components: {
    TrendArrow
  },
  props: {
    categories: {
      type: Array,
      default: () => []
    },
    data: {
      type: Object,
      default: () => {}
    },
    id: {
      type: String,
      default: ''
    },
    onOpenCategoryDetails: {
      type: Function,
      default: () => {}
    },
    shouldHideAverages: {
      type: Boolean,
      default: false
    },
    shouldShowColorSegments: {
      type: Boolean,
      default: false
    },
    surveyName: {
      type: String,
      default: ''
    },
    theme: {
      type: String,
      default: ''
    },
    userIsAdminForCurrentGroupOrSuperAdmin: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getBarColor(value) {
      if (this.theme === 'monochrome') {
        return 'monochrome'
      } else {
        switch (true) {
          case value >= 0 && value < 4:
            return 'red'
          case value >= 4 && value < 7:
            return 'yellow'
          case value >= 7:
            return 'green'
          default:
            break
        }
      }
    },
    showTrendForCategory(category) {
      return !this.shouldHideAverages && category?.regressionValues?.length > 1
    }
  }
}
</script>

<style lang="scss" scoped>
@use '../../../../assets/scss/_brand.scss' as *;
.category-bar {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-gap: 10px 20px;
  padding: 3px;
  cursor: pointer;
  > :hover {
    border-radius: 5px;
    background: var(--kt-list-group-action-active-bg);
  }

  .category {
    display: flex;
    flex: 0 0 50%;
    .name-and-progress {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: flex-end;
      .name {
        font-size: 1.4em;
        margin-bottom: 5px;
      }
      .progress {
        margin-bottom: 2px;
        height: 10px;
        border-radius: 5px;

        &-bar {
          border-radius: 6px;
          &-red {
            background-color: $brand-red;
          }
          &-yellow {
            background-color: $brand-yellow;
          }
          &-green {
            background-color: $brand-green;
          }
          &-monochrome {
            background-color: $brand-monochrome;
          }
        }
        &.outline {
          border: 1px solid (var(--kt-results-red));
        }
      }
    }
  }
}

.should-hide-averages {
  border: 1px solid #bbb;
}

@media all and (max-width: 991px) {
  .category {
    flex-basis: 100%;
  }
}

.value-placeholder {
  width: 25px;
}

// Do we really need this?
// @media print {
//   .name-and-progress {
//     flex: 1;
//     display: flex;
//     flex-direction: column;
//     padding-bottom: 0px;
//   }
//   .progress {
//     position: relative;
//     &:before {
//       display: block;
//       content: '';
//       position: absolute;
//       top: 0;
//       right: 0;
//       bottom: 0;
//       left: 0;
//       z-index: 0;
//       border-bottom: 15px solid #ddd;
//     }
//     &-bar {
//       position: absolute;
//       top: 0;
//       bottom: 0;
//       left: 0;
//       z-index: 1;
//       border-bottom: 15px solid #ddd;
//       &.green {
//         border-bottom-color: $brand-green;
//       }
//       &.yellow {
//         border-bottom-color: $brand-yellow;
//       }
//       &.red {
//         border-bottom-color: $brand-red;
//       }
//     }
//   }
// }
</style>
